import { useHttp } from '@/api';
import { httpApi } from '@/api/api';


/**
 * 採番一覧：検索条件リストの初期化(状態)
 */
export function initNumberSearchList() {
  return new Promise((resolve, reject) => {
    useHttp()
      .request(httpApi.InitNumberSearchList)
      .then(res => {
        resolve(res)
      })
      .catch(err => {
        reject(err)
      })
  })
}


/**
 *  採番一覧：検索採番台帳基本情報
 */
export function getNumberBasicInfo(data) {

  return new Promise((resolve, reject) => {
    useHttp()
      .request(httpApi.GetNumberBasicInfo, data)
      .then(res => {
        resolve(res)
      })
      .catch(err => {
        reject(err)
      })
  })
}


/**
 *  採番一覧：削除採番台帳基本情報
 */
export function deleteNumberBasicInfo(data) {

  return new Promise((resolve, reject) => {
    useHttp()
      .request(httpApi.DeleteNumberBasicInfo, data)
      .then(res => {
        resolve(res)
      })
      .catch(err => {
        reject(err)
      })
  })
}

/**
 * 採番詳細：リストの初期化(担当者、見積状態)
 */
export function initNumberDetailList() {
  return new Promise((resolve, reject) => {
    useHttp()
      .request(httpApi.InitNumberDetailList)
      .then(res => {
        resolve(res)
      })
      .catch(err => {
        reject(err)
      })
  })
}

/**
 * 採番詳細：リストの初期化(得意先担当者)
 */
export function initNumberDetailCusUserList(data) {
  return new Promise((resolve, reject) => {
    useHttp()
      .request(httpApi.InitNumberDetailCusUserList,data)
      .then(res => {
        resolve(res)
      })
      .catch(err => {
        reject(err)
      })
  })
}

/**
 * 採番詳細：検索採番台帳情報
 */
export function searchNumberDetailByNbQuoteNo(data) {
  return new Promise((resolve, reject) => {
    useHttp()
      .request(httpApi.SearchNumberDetailByNbQuoteNo, data)
      .then(res => {
        resolve(res)
      })
      .catch(err => {
        reject(err)
      })
  })
}

/**
 * 採番詳細：新規採番台帳情報
 */
export function addNumberInfo(data, callBackFn) {
  return new Promise((resolve, reject) => {
    useHttp()
      .request(httpApi.AddNumberInfo, data)
      .then(res => {
        resolve(res)
        callBackFn()
      })
      .catch(err => {
        reject(err)
      })
  })
}

/**
 * 採番詳細：編集採番台帳情報
 */
export function editNumberInfo(data, callBackFn) {
  return new Promise((resolve, reject) => {
    useHttp()
      .request(httpApi.EditNumberInfo, data)
      .then(res => {
        resolve(res)
        callBackFn()
      })
      .catch(err => {
        reject(err)
      })
  })
}

/**
 * 採番詳細：編集採番台帳情報(処理)
 */
export function editNumberInfoByProcessing(data, callBackFn) {
  return new Promise((resolve, reject) => {
    useHttp()
      .request(httpApi.EditNumberInfoByProcessing, data)
      .then(res => {
        resolve(res)
        callBackFn()
      })
      .catch(err => {
        reject(err)
      })
  })
}


/**
 * 採番詳細：編集採番台帳情報(得意先担当者)
 */
export function editNumberInfoByCustomer(data, callBackFn) {
  return new Promise((resolve, reject) => {
    useHttp()
      .request(httpApi.EditNumberInfoByCustomer, data)
      .then(res => {
        resolve(res)
        callBackFn()
      })
      .catch(err => {
        reject(err)
      })
  })
}


/**
 * 採番詳細：編集採番台帳情報(処理)
 */
export function searchNumberDetailProcessingByNbQuoteNo(data) {
  return new Promise((resolve, reject) => {
    useHttp()
      .request(httpApi.SearchNumberDetailProcessingByNbQuoteNo, data)
      .then(res => {
        resolve(res)
      })
      .catch(err => {
        reject(err)
      })
  })
}


/**
 * 採番詳細：編集採番台帳情報(得意先)
 */
export function searchNumberDetailCustomerByNbQuoteNo(data) {
  return new Promise((resolve, reject) => {
    useHttp()
      .request(httpApi.SearchNumberDetailCustomerByNbQuoteNo, data)
      .then(res => {
        resolve(res)
      })
      .catch(err => {
        reject(err)
      })
  })
}

/**
 * 採番詳細：再度見積
 */
export function estimateAgain(data, callBackFn) {
  return new Promise((resolve, reject) => {
    useHttp()
      .request(httpApi.EstimateAgain, data)
      .then(res => {
        resolve(res)
        callBackFn()
      })
      .catch(err => {
        reject(err)
      })
  })
}

/**
 * 採番詳細：再度受注
 */
export function orderAgain(data, callBackFn) {
  return new Promise((resolve, reject) => {
    useHttp()
      .request(httpApi.OrderAgain, data)
      .then(res => {
        resolve(res)
        callBackFn()
      })
      .catch(err => {
        reject(err)
      })
  })
}

/**
 * 採番詳細：編集採番台帳情報(見積書情報と本社情報)
 */
export function editNumberInfoEsimateAndCompany(data, callBackFn) {
  return new Promise((resolve, reject) => {
    useHttp()
      .request(httpApi.EditNumberInfoEsimateAndCompany, data)
      .then(res => {
        resolve(res)
        callBackFn()
      })
      .catch(err => {
        reject(err)
      })
  })
}


/**
 * 採番詳細：すべてのレートを取得する
 */
export function getAllRate(data, callBackFn) {
  return new Promise((resolve, reject) => {
    useHttp()
      .request(httpApi.GetAllRate, data)
      .then(res => {
        resolve(res)
        callBackFn()
      })
      .catch(err => {
        reject(err)
      })
  })
}


/**
 * 採番詳細：見積依頼書出力
 */
export function OutPutReqQuotationExcel(data) {
  return new Promise((resolve, reject) => {
    useHttp()
      .request(httpApi.OutPutReqQuotationExcel,data)
      .then(res => {
        resolve(res)
      })
      .catch(err => {
        reject(err)
      })
  })
}

/**
 * 採番詳細：見積書出力
 */
export function OutPutQuotationExcel(data) {
  return new Promise((resolve, reject) => {
    useHttp()
      .request(httpApi.OutPutQuotationExcel,data,true)
      .then(res => {
        resolve(res)
      })
      .catch(err => {
        reject(err)
      })
  })
}

/**
 * 採番詳細：見積書情報の取得
 */
export function GetEstimateInfo(data) {
  return new Promise((resolve, reject) => {
    useHttp()
      .request(httpApi.GetEstimateInfo,data)
      .then(res => {
        resolve(res)
      })
      .catch(err => {
        reject(err)
      })
  })
}

/**
 * 採番詳細：見積状態の自動変更
 */
export function EditQuoteStateByQuoteNo(data) {
  return new Promise((resolve, reject) => {
    useHttp()
      .request(httpApi.EditQuoteStateByQuoteNo,data)
      .then(res => {
        resolve(res)
      })
      .catch(err => {
        reject(err)
      })
  })
}

